<template>
	<div v-if="displayable" class="col-md-4 col-xl-3">
		<div class="card-box product-box ribbon-box">
			<template v-if="product.stock !== 0">
				<template v-if="! hasVariant">
					<template v-if="product.discount_percentage === 0">
						<div class="" />
					</template>
					<template v-else-if="product.discount_percentage >= 1 && product.discount_percentage <= 20 ">
						<div class="ribbon ribbon-blue float-left" style="position: absolute;">
							{{ product.discount_percentage }}% de
							desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 21 && product.discount_percentage <= 50">
						<div class="ribbon ribbon-success float-left" style="position: absolute;">
							{{ product.discount_percentage }}%
							de desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 51 && product.discount_percentage <= 75">
						<div class="ribbon ribbon-pink float-left" style="position: absolute;">
							{{ product.discount_percentage }}% de
							desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 76">
						<div class="ribbon ribbon-danger float-left" style="position: absolute;">
							{{ product.discount_percentage }}%
							de desconto
						</div>
					</template>
				</template>

				<template v-else-if="hasVariant && variantHasDiscount">
					<template v-if="product.discount_percentage === 0">
						<div class="" />
					</template>
					<template v-else-if="product.discount_percentage >= 1 && product.discount_percentage <= 20 ">
						<div class="ribbon ribbon-blue float-left" style="position: absolute;">
							{{ product.discount_percentage }}% de
							desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 21 && product.discount_percentage <= 50">
						<div class="ribbon ribbon-success float-left" style="position: absolute;">
							{{ product.discount_percentage }}%
							de desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 51 && product.discount_percentage <= 75">
						<div class="ribbon ribbon-pink float-left" style="position: absolute;">
							{{ product.discount_percentage }}% de
							desconto
						</div>
					</template>
					<template v-else-if="product.discount_percentage >= 76">
						<div class="ribbon ribbon-danger float-left" style="position: absolute;">
							{{ product.discount_percentage }}%
							de desconto
						</div>
					</template>
				</template>
			</template>

			<!--TODO: Esses links devem aparecer somente para quem tiver a permissão -->
			<div class="product-action">
				<a
					v-if="canEdit"
					:href="vueRoute('ecommerce.product.edit', product.slug)"
					class="btn btn-success btn-xs waves-effect waves-light"
				>
					<i class="mdi mdi-pencil" />
				</a>
				<a
					v-if="canRemove"
					href="javascript: void(0);"
					class="btn btn-danger btn-xs waves-effect waves-light"
					@click="deleteProduct(product.id)"
				>
					<i class="mdi mdi-close" />
				</a>
			</div>

			<div class="bg-light wrapper-img">
				<img
					:src="file"
					:alt="product.meta_title"
					class="img-fluid normalize-image"
					@error="imgUrlAlt"
				>
			</div>

			<div class="product-info">
				<div class="row align-items-center">
					<div class="col-12">
						<h5 class="font-16 mt-0 sp-line-1">
							<a :href="vueRoute('ecommerce.product.show', product.slug)" class="text-dark">
								{{ product.name }}
							</a>
						</h5>
						<!--                        TODO: Implementar rating baseado nas pontuações atribuída pelos utilizadores -->
						<!--                        <Rating :grade="1" :maxStars="5" :hasCounter="false"></Rating>-->
					</div>
					<template v-if="saleWithoutStock === false">
						<div class="col-12 pb-2">
							<template v-if="product.discount_percentage">
								<div class="product-price-tag" style="margin-bottom: 15px;">
									<span v-if="hasVariant">
										<span v-if="variantHasDiscount">
											De
											<del>
												{{ variantPrice | toCurrency }}
											</del>
											por: {{ calculateVariantDiscount | toCurrency }}
										</span>
										<span v-else>
											{{ variantPrice | toCurrency }}
										</span>
									</span>
									<span v-else>
										De
										<del>
											{{ product.prices.wholesale | toCurrency }}
										</del>
										por: {{ calculateDiscount | toCurrency }}
									</span>
								</div>
							</template>
							<template v-else>
								<div class="product-price-tag">
									<span v-if="hasVariant">
										{{ variantPrice | toCurrency }}
									</span>
									<span v-else>
										{{ product.prices.wholesale | toCurrency }}
									</span>
								</div>
							</template>
						</div>

						<template v-if="hasVariant">
							<div :class="activeVariant">
								<label for="variant">Variantes:</label>
								<select id="variant" v-model="product.variant" class="form-control">
									<option v-for="(variant, index) in variations" :key="index" :value="variant.id">
										{{ variant.description }}
									</option>
								</select>
							</div>
						</template>
						<div :class="[ hasVariant ? activeVariant : inactiveVariant ]">
							<label :for="`product_${product.id}`">Quantidade:</label>
							<input :id="`product_${product.id}`" class="text-center" value="1" type="text">
						</div>

						<div class="col-12">
							<a
								class="btn btn-outline-success btn-block btn-rounded waves-effect waves-light"
								href="javascript:void(0)"
								@click="addToCart"
							>
								<i class="mdi mdi-cart" />
								Adicionar no carrinho
							</a>
						</div>
						<div class="col-12 mt-1">
							<a
								class="btn btn-outline-info btn-block btn-rounded waves-effect waves-light"
								:href="vueRoute('ecommerce.product.show', product.slug)"
							>
								<i class="mdi mdi-information-outline" />
								Ver informações
							</a>
						</div>
					</template>
					<template v-else>
						<div class="col-12">
							<h3 class="text-center">
								Produto indisponível
							</h3>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import Rating from "../Rating";
import Swal from 'sweetalert2';

export default {
    name: "ProductDetails",
    // components: {Rating},

    props: {
        product: {
            type: Object,
            default: () => ({
                prices: {
                    retail: 0,
                    wholesale: 0,
                },
                files: [],
                meta_title: null,
            }),
            variant: null,
            cd: null,
        },
        variations: {
            type: Array,
            default: () => ([])
        },
        canEdit: {
            type: Boolean,
            default: false,
        },
        canRemove: {
            type: Boolean,
            default: false,
        },
        saleWithoutStock: {
            type: Boolean,
            default: false,
        },
      distributionCenterSelected: {
        type: Object,
        default: null,
      },
    },
    data() {
        return {
            touchspin: undefined,
            activeVariant: 'col-md-12 col-sm-12 pb-3',
            inactiveVariant: 'col-md-12 pb-3',
        }
    },

    computed: {
        files() {
            if (this.product.hasOwnProperty('files') && this.product.files.length > 0) {
                return this.product.files;
            }

            return [];
        },
        file() {
            if (this.product.hasOwnProperty('files') && this.product.files.length > 0) {
                return this.product.files[0].url;
            }

            return '';
        },
        calculateDiscount() {
            let percentageDiscount = parseFloat(this.product.discount_percentage)
            let valueProduct = parseFloat(this.product.prices.wholesale)
            let totalValue = 0

            if (percentageDiscount !== 0) {
                totalValue = valueProduct - (valueProduct * percentageDiscount / 100).toFixed(2)
                return totalValue
            }
            return 0
        },
        calculateVariantDiscount() {
          let percentageDiscount = parseFloat(this.product.discount_percentage)
          let vat = this.product.variant
          let el = this.variations.find((item) => item.id === vat)
          let valueProduct = parseFloat(el.price_wholesale)
          let totalValue = 0

          if (percentageDiscount !== 0) {
            totalValue = valueProduct - (valueProduct * percentageDiscount / 100).toFixed(2)
            return totalValue
          }
          return 0
        },

        hasVariant() {
            return this.variations.length > 0;
        },
        displayable() {
            if (!this.product.variants) {
                return true;
            }
            return this.product.variations.length > 0
        },
        variantPrice() {
          let vat = this.product.variant
          let el = this.variations.find((item) => item.id === vat)
          return el?.price_wholesale
        },
        variantHasDiscount() {
          let vat = this.product.variant
          let el = this.variations.find((item) => item.id === vat)
          return el?.with_discount === 'S'
        },
    },

    mounted() {
        this.initTouchspin();
        this.selectCenter();
    },

    methods: {
        initTouchspin() {
            this.touchspin = $(`#product_${this.product.id}`).TouchSpin({
                buttondown_class: 'btn btn-light',
                buttonup_class: 'btn btn-light',
                min: 1,
            })
        },
        selectCenter() {
            this.product.cd = this.distributionCenterSelected.id
        },
        addToCart() {
            this.product.quantity = this.touchspin.val();
            console.log(this.product)
            this.$emit('add-item', this.product);
        },
        deleteProduct() {
            const swallWithBootstrapButtons = Swal.mixin({
                buttonsStyling: true
            });

            swallWithBootstrapButtons.fire({
                html: `<b>${window.userAuth.name}!</b><br/> Tem certeza que deseja remover este produto?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Apagar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    axios.delete(route('api.ecommerce.product.destroy', this.product.slug)).then(response => {
                        toastSuccess('Apagado com sucesso!');
                        this.$emit('product-removed', this.product.id)
                    }).catch(error => {
                        toastError();
                        console.log(error)
                    });

                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    toastInfo();
                }
            }).catch(error => {
                toastError()
            });
        }
    }
}
</script>

<style scoped lang="scss">
.wrapper-img {
	text-align: center;
}

.normalize-image {
    //height: 250px;
    //width: 250px;
}
</style>
